import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/fan-pics/")({
  beforeLoad: () => {
    throw redirect({ to: "/fan-pics/uploads" });
  },
});
